import PropTypes from 'prop-types';
import {createUseStyles} from 'react-jss';
import {connect} from 'react-redux';
import Button from '../../../../UI/Button/Button';
import {hideOverlay} from '../../../actions/overlay-actions';
import Translation from '../../../lang/Translation';
import Spacing from '../../../style-helper/Spacing';
import CheckoutOverlay from '../CheckoutOverlay';
import ClickAndCollectDropshipContent from './OverlayContent/ClickAndCollectDropshipContent';

const useStyles = createUseStyles({
  deliveryInformationOverlay: {
    fontSize: 14,
  },
  content: {
    marginBottom: Spacing.single,
  },
  buttonContainer: {
    marginTop: Spacing.quad,
  },
});

export function DeliveryInformationOverlay(props) {
  const classes = useStyles();
  return (
    <CheckoutOverlay
      popup
      className={classes.deliveryInformationOverlay}
      data-test="DeliveryInformationOverlay"
      title="link.more.info"
    >
      <div className={classes.content}>
        <ClickAndCollectDropshipContent />
      </div>
      <div className={classes.buttonContainer}>
        <Button
          id="DeliveryInformationOverlay__closeButton"
          primary
          fullWidth
          onClick={props.hideOverlay}
        >
          <Translation>checkout.close.button</Translation>
        </Button>
      </div>
    </CheckoutOverlay>
  );
}

DeliveryInformationOverlay.propTypes = {
  hideOverlay: PropTypes.func.isRequired,
};

export default connect(null, {hideOverlay})(DeliveryInformationOverlay);
